<template>
  <main class="policy">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">会社方針</h1>
        </div>
        <p class="">
豊嶋精密工業は、1959年度以来創業者の言葉を金言として仕事に向き合うことで、精密板金において多くの企業様にご信頼をいただき確実な製品をお届けしております。
				</p>
				<ul>
<li>規律</li>
<li>協調性</li>
<li>責任</li>
<li>積極性</li>
<li>知識技術</li>
<li>仕事の正確さ</li>
<li>仕事の迅速さ</li>
        </ul>
      </div>

    <section class="tagJumpTarget areaAboutGreeting" id="AboutGreeting">
      <div class="areaH2">
        <h2>ご挨拶</h2>
      </div>
        <div class="rowView">
					<p>
当社は昭和34年6月に設立され、長きにわたって放送局用業務用カメラをはじめとした映像装置や電源装置の部品を板金加工する業を営んでまいりました。<br>
<br>
お得意先様と密な連携をとり、商品開発やコストダウンに貢献し、現在も創業以来掲げている「お客様への貢献」を第一義とし、より安く、高品質な商品を提供すべく日夜尽力しております。<br>
<br>
当社はお取引先様とのお取引を丁寧にかつ迅速に行うことを常としつつ、今後もお取引先様との信頼を大切に、社業に勤しんでまいります。<br>
<br>
このお客様第一主義、とも呼べる意識を軸に、何事にも「感謝」の気持ちを忘れずに取り組むことが当社社員の作法です。社の長として、社員へこの作法を欠かさずに行うことを常日頃より指導しております。<br>
<br>
また、品質も、他社様からのご要望を超えた「豊嶋精密工業クオリティ」を追求し、品質では他社様に負けない、高品質な製品作りにこだわった運営をしてまいります。<br>
<br>
より多くの企業様により多くのご信頼を得るべく、これからも日夜業務に励んでまいります。<br>
<br>
これからの弊社の活動に刮目ください。
          </p>
					<p class="signature">
<span>代表取締役</span>豊嶋唯充
					</p>
        </div>
    </section>

    <section class="tagJumpTarget areaAboutQuality" id="AboutQuality">
      <div class="areaH2">
        <h2>品質方針</h2>
      </div>
      <div class="rowView">
				<div class="_text">
					<p>2024年1月4日</p>
					<p>
豊嶋精密工業株式会社<span class="brSp"></span> 代表取締役社長 豊嶋唯充
					</p>
				</div>
				<ul>
					<li>
						<h3>豊嶋精密工業の品質</h3>
						<p>
お客様第一に徹し、お客様に満足していただける安全で高品質な製品及びサービス
を安定的に供給することで、社会に貢献します。
						</p>
					</li>
					<li>
						<h3>品質向上活動</h3>
						<p>
当社の全従業員が参加し、協力会社と連携して品質向上活動に取り組みます。
いかなる難題にも挑戦し、常に品質の継続的改善に努力し続けます。
						</p>
					</li>
					<li>
						<h3>法令等の遵守</h3>
						<p>
品質に関する法令及び当社として同意した要求事項を遵守します。
						</p>
					</li>
					<li>
						<h3>継続的改善</h3>
						<p>
品質目標を策定し、品質マネジメントシステムの継続的改善を図ります。
						</p>
					</li>
				</ul>
				<div class="_block tagJumpTarget" id="AboutQualityISO">
					<h3><span>国際標準規格承認</span></h3>
					<p>
2024年11月当社品質マネージメントシステムは<router-link :to="{path:'/about', hash:'AboutISO'}" class="pageLink">国際標準化機構：ISOの審査を経て国際標準規格として承認</router-link>されました。
					</p>
				</div>
			</div>
		</section>

    <section class="tagJumpTarget areaAboutEA21" id="AboutEA21">
      <div class="areaH2">
        <h2>社会貢献活動</h2>
      </div>
      <div class="rowView">
				<p>
環境への取り組み推進のため、<a href="https://www.ea21.jp/" target="_blank"  rel="nofollow" class="externalLink">エコアクション21(ES21)</a>を2014年2月認証取得し実施しています。
				</p>
				<h3><span>エコアクション21</span></h3>
				<p class="ea21">
<img src="/asset/images/pages/ea21_logo.png" alt="エコアクション21 認証番号0009902">
認証番号0009902
				</p>
				<div class="_block noteContent">
<q cite="https://www.ea21.jp/ea21/">
    <p>
エコアクション21は、環境省が策定した日本独自の環境マネジメントシステム（EMS）です。<br>
一般に、「PDCAサイクル」と呼ばれるパフォーマンスを継続的に改善する手法を基礎として、組織や事業者等が環境への取り組みを自主的に行うための方法を定めています。
		</p>
</q>
<p><cite>一般財団法人 持続性推進機構（IPSuS）</cite></p>
				</div>
				<div class="_block">
					<div class="_grid">
						<h4>エコアクション<br>認証・登録証</h4>
						<p>
<span>登録有効期間：<span class="brSp"></span>2024年2月7日〜2026年2月16日</span>
<img-plus img-src="documents/ea21Certificate20260217-20280216.pdf" img-thumb="" img-alt="エコアクション認証・登録証20260217-20280216" :full-screen="true" at-place="single" get-outside="" />
						</p>
					</div>
					<div class="_list">
						<h4>活動報告</h4>
						<ul>
							<li>
<router-link :to="{path:'/about/official?list=1', hash:'o-0004'}" class="pageLink">環境経営レポート2024年7月1日～2025年6月30日</router-link>
							</li>
						</ul>
					</div>

				</div>
			</div>

		</section>


		</div>
  </main>
</template>

<script>
import imgPlus from '@/components/ImgPlus.vue'

export default {
  name: 'policy',
  components:{
    imgPlus,
  },
	data() {
		return {
			pageTitle:"会社方針",
			description:"豊嶋精密工業株式会社の会社方針をご説明します",
			keywords:"会社方針 社会貢献活動 代表挨拶",
			ogType:"article",
		}
	},
  mounted: function() {this._log("mounted "+this.$options.name)
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')
	/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
	
			this.changePageScrollAnchor()
		}
  },
  updated: function() {
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

			this.changePageScrollAnchor()
		}
  },
  methods: {
/*
    handleScrollForBackground:function (evt, el) {
//チェック用のエリア設定
      let aViewRect = this.makeViewRect()
      let aViewCenter = parseInt(aViewRect.height/2)
//      let adjustment = window.innerHeight
//対象オブジェクトの情報設定
      const rect = el.getBoundingClientRect()
      const styles = window.getComputedStyle(el)
//対象オブジェクトの実際のサイズ設定
      let rectTopPlusMargin = rect.top - parseInt(styles.marginTop)
      let rectBottomPlusMargin = rect.bottom - parseInt(styles.marginBottom) 
//表示状態保持チェック
      if(this.$_refChangedBuffer() != "") {
        if(this.$_refChangedBuffer() == el.id && (rectBottomPlusMargin < aViewCenter || rectTopPlusMargin > aViewCenter)) {
           this.$_setChangedBuffer("")
        }
        return false
//表示変更チェック
      } else if((aViewRect.top < rectBottomPlusMargin && rectTopPlusMargin < aViewCenter) || (aViewCenter < rect.top && rectTopPlusMargin < aViewCenter)){
        switch(el.id) {
          case 'AboutGreeting':
            this.$store.commit('updatePageBackgroundStyle', 'appBackgroundBase')
            this.$_setChangedBuffer(el.id)
            break;
          case 'AboutPhilosophy':
            this.$store.commit('updatePageBackgroundStyle', 'aboutBack')
            this.$_setChangedBuffer(el.id)
            break;
          case 'AboutOpening':
            this.$store.commit('updatePageBackgroundStyle', 'appBackgroundBase')
            this.$_setChangedBuffer(el.id)
            break;
          case 'AboutMemberVoice':
            this.$store.commit('updatePageBackgroundStyle', 'appBackgroundBase')
            this.$_setChangedBuffer(el.id)
            break;
          default:
        }
      }
    },
*/
    makeViewRect() {
//背景切り替え用の場所の定義を行う
      const maxHeight = 480 //高さの制限
      let aX = 0
      let aY = 0
      let aWidth = window.innerWidth
      let aHeight = (window.innerHeight/2 > maxHeight)? maxHeight:window.innerHeight/2
      return new DOMRectReadOnly(aX,aY,aWidth,aHeight)
    },
  },
  beforeDestroy:function() {console.log("beforeDestroy "+this.$options.name)
    this.$_setChangedBuffer("")
  },
/*
  destroy:function() {console.log("destroy "+this.$options.name)},
  activated:function() {console.log("activated "+this.$options.name)},
  deactivated:function() {console.log("deactivated "+this.$options.name)},
  beforeUnmount:function() {console.log("beforeUnmount "+this.$options.name)},
  unmounted:function() {console.log("unmounted "+this.$options.name)},
*/
}
</script>

<style>


</style>
